import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout, getNombreFromToken } from './services/auth';
import WhatsAppConnect from './pages/WhatsAppConnect'; // <-- Importar el componente
import './Principal.css';

export default function Principal() {
  const [seccionActual, setSeccionActual] = useState('signup');
  const [nombreUsuario, setNombreUsuario] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const nombre = getNombreFromToken();
    setNombreUsuario(nombre || 'Usuario');
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const renderSeccion = () => {
    switch (seccionActual) {
      case 'signup':
        return (
          <div className="seccion-bienvenida">
            <h2>🚀 Registra tu empresa</h2>
            <p>Completa los datos para crear tu cuenta y empezar a usar el bot de WhatsApp.</p>
            <p className="seccion-mensaje">📝 Próximamente: formulario de registro</p>
          </div>
        );
      case 'documentos':
        return (
          <div className="seccion-bienvenida">
            <h2>📄 Subir Documentos</h2>
            <p>Sube tus archivos (PDF, TXT) para que el bot pueda responder con información precisa.</p>
            <p className="seccion-mensaje">📎 Próximamente: área de subida de archivos</p>
          </div>
        );
      case 'whatsapp':
        return <WhatsAppConnect />; // <-- Ahora renderiza el componente real
      case 'configuracion':
        return (
          <div className="seccion-bienvenida">
            <h2>⚙️ Configuración</h2>
            <p>Ajusta las preferencias de tu cuenta y empresa.</p>
            <p className="seccion-mensaje">🔧 Próximamente: opciones de configuración</p>
          </div>
        );
      default:
        return <div className="seccion-bienvenida"><h2>Bienvenido a KleverBotBase</h2></div>;
    }
  };

  const menuItems = [
    { id: 'signup', icon: '🚀', label: 'Registrar Empresa' },
    { id: 'documentos', icon: '📄', label: 'Documentos' },
    { id: 'whatsapp', icon: '📱', label: 'WhatsApp' },
    { id: 'configuracion', icon: '⚙️', label: 'Configuración' },
  ];

  return (
    <div className="principal-layout">
      {/* BARRA LATERAL */}
      <aside className="principal-sidebar">
        <div className="principal-sidebar-logo">
          <img 
            src="/logo2.png" 
            alt="KleverBotBase" 
            className="principal-logo-img"
          />
        </div>

        <nav className="principal-sidebar-nav">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => setSeccionActual(item.id)}
              className={`principal-sidebar-btn ${seccionActual === item.id ? 'active' : ''}`}
              title={item.label}
            >
              <span className="principal-sidebar-icon">{item.icon}</span>
            </button>
          ))}
        </nav>
      </aside>

      {/* CONTENIDO PRINCIPAL */}
      <main className="principal-main">
        <header className="principal-header">
          <div className="principal-header-left">
            <img 
              src="/sinteligen4.png" 
              alt="KleverBotBase" 
              className="principal-header-logo"
            />
          </div>

          <div className="principal-header-right">
            <span className="principal-user-name">👤 {nombreUsuario}</span>
            <button className="principal-logout-btn" onClick={handleLogout}>
              Cerrar sesión
            </button>
          </div>
        </header>

        <div className="principal-content">
          {renderSeccion()}
        </div>
      </main>
    </div>
  );
}